<template>
  <div>
    <!-- FORGOT PASSWORD DIALOG -->
    <app-dialog :dialogShow="forgotPasswordDialogShow" :max-width="400" :title="$t(`label.forgotPassword`).slice(0, -1)" :closeAction="this.closeForgotPasswordDialog" :customClass="'pa-0'">
      <app-forgot-password :openRegisterDialog="openRegister" :openLoginDialog="openLogin"></app-forgot-password>
    </app-dialog>
    <v-row no-gutters class="login_panel" v-if="$vuetify.breakpoint.mdAndUp" :class="$vuetify.breakpoint.mdAndDown ? '' : 'mt-12 my-6'">
      <v-col cols="12" class="pa-0 login_wrapper">
        <span class="registerTitle">{{ $t(`label.login`) }}</span>
      </v-col>
    </v-row>
    <v-row no-gutters v-if="!$vuetify.breakpoint.mdAndUp">
      <v-carousel delimiter-icon="mdi-minus" hide-delimiters :show-arrows="false" cycle interval="10000" height="auto">
        <v-carousel-item v-for="(registrationBanner, i) in registrationBannerContent" :key="i" style="display: grid">
          <v-img :src="`${registrationBanner.desktop_registration_banner}`" :contain="true"></v-img>
        </v-carousel-item>
      </v-carousel>
    </v-row>
    <v-row no-gutters v-if="!$vuetify.breakpoint.mdAndUp">
      <v-col cols="6" @click="openLogin()" class="login-page-login-button d-flex justify-center align-center no-gutters">
        <b class="py-4">{{ $t(`label.login`) }}</b>
      </v-col>
      <v-col cols="6" @click="this.openRegister" class="login-page-register-button d-flex justify-center align-center no-gutters">
        <b class="py-4">{{ $t(`label.register`) }}</b>
      </v-col>
    </v-row>
    <v-row no-gutters class="login_panel" :class="$vuetify.breakpoint.mdAndDown ? '' : 'mb-12'">
      <v-row no-gutters class="login_wrapper" :class="$vuetify.breakpoint.mdAndDown ? 'pt-5' : 'pb-8'">
        <v-row no-gutters class="loginPageGuideSection hidden-md-and-up" v-if="showRegisterGuide">
          <v-col class="pa-0" cols="12">
            <div class="d-flex align-center white--text">
              <img loading="lazy" src="/static/svg/icon_exit.svg" width="25" height="25" :contain="true" @click="closeShowRegisterGuide()" />
              <label class="px-3">{{ $t(`label.loginGuide`) }} {{ $t(`label.clickThisButton`) }} {{ $t(`label.watchVideo`) }}</label>
              <v-btn class="circle-button text-capitalize" style="color: #000000; background: #FFC000;">
                {{ $t(`label.watchVideo`) }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="no-gutters left-container">
            <v-form ref="loginForm">
              <app-form-field
                :enabledLabel="true"
                v-model.trim="loginObj.memberCode"
                :label="$t(`field.username`)"
                :placeholder="$t(`fieldHint.fillUpHere`)"
                :rules="validator.usernameRules()"
              ></app-form-field>
              <app-form-field
                :enabledLabel="true"
                v-model.trim="loginObj.password"
                :label="$t(`field.password`)"
                :placeholder="$t(`fieldHint.fillUpHere`)"
                :rules="validator.passwordRules()"
                :allowShowPassword="false"
                type="password"
              ></app-form-field>
              <v-row no-gutters>
                <v-col cols="12" class="text-right forgot-password">
                  <v-btn text height="auto" @click="openForgotPasswordDialog" class="text-capitalize pr-0">
                    {{ $t(`label.forgotPassword`) }}
                  </v-btn>
                </v-col>
              </v-row>
              <!-- <app-button :action="this.login" :title="$t(`button.login`)"></app-button> -->
              <v-row no-gutters>
                <v-col cols="12">
                  <v-btn height="auto" @click="this.login" class="button-primary full-width font-weight-bold">
                    {{ $t(`button.login`) }}
                  </v-btn>
                  <!-- <button-primary
                      :title="$t('button.login')"
                      @action="this.login"
                      :customClass="'full-width font-weight-bold'">
                  </button-primary> -->
                </v-col>
                <v-col cols="12" class="text-center">
                  <label v-show="loginErrorMsg" class="red--text subtitle-2">{{ loginErrorMsg }}</label>
                  <label v-show="fullPageLoginErrMsg" class="red--text subtitle-2">{{ fullPageLoginErrMsg }}</label>
                </v-col>
              </v-row>
            </v-form>
            <v-row no-gutters class="d-flex justify-center align-center cols">
              <p class="mt-5 text-center body-1" style="color: #FFFFFF;">
                {{ $t(`message.dontHaveAccount`) }}
                <v-btn text height="auto" @click="openRegister()" class="pa-0" style="color: #FF5AE4; text-decoration: underline; text-transform: none;">{{ $t(`label.signUp`) }}</v-btn>
              </p>
            </v-row>
            <v-divider style="border-color: #FF5AE4;"></v-divider>
            <v-row no-gutters class="d-flex justify-center align-center cols">
              <p class="mt-5 text-center body-1" style="color: #FFFFFF;">
                {{ $t(`message.loginDescriptionMessage`) }}
                <v-btn text height="auto" @click="openRegister()" class="pa-0" style="color: #FFC000; text-transform: none;">{{ $t(`label.customerService`) }}</v-btn>
                {{ $t(`message.loginDescriptionMessage2`) }}
              </p>
            </v-row>
          </v-col>
          <v-col class="no-gutters right-container hidden-sm-and-down" cols="12" :md="8">
            <v-row no-gutters class="loginPageGuideSection hidden-sm-and-down" v-if="showRegisterGuide">
              <v-col class="pa-0" cols="12">
                <div class="d-flex align-center white--text">
                  <img loading="lazy" src="/static/svg/icon_exit.svg" width="25" height="25" :contain="true" @click="closeShowRegisterGuide()" />
                  <label class="px-3">{{ $t(`label.loginGuide`) }} {{ $t(`label.clickThisButton`) }} {{ $t(`label.watchVideo`) }}</label>
                  <v-btn class="circle-button text-capitalize" style="color: #000000; background: #FFC000;">
                    {{ $t(`label.watchVideo`) }}
                  </v-btn>
                </div>
              </v-col>
              <!--            <v-col cols="1" class="pa-0 d-flex justify-center align-center">-->
              <!--              <v-img @click="closeShowRegisterGuide()" src="/static/image/profile/closeIcon.png" width="15" height="15" :contain="true"></v-img>-->
              <!--            </v-col>-->
            </v-row>
            <v-carousel delimiter-icon="mdi-minus" hide-delimiters :show-arrows="false" cycle interval="10000" height="auto">
              <v-carousel-item v-for="(registrationBanner, i) in registrationBannerContent" :key="i" style="display: grid">
                <v-img :src="`${registrationBanner.desktop_registration_banner}`" :contain="true"></v-img>
              </v-carousel-item>
            </v-carousel>
            <v-row v-if="false" class="rebate-display">
              <v-col cols="2">
                <div class="icon"></div>
                <span class="percentage">0.6%</span>
                <span>Slots Rebate(%)</span>
              </v-col>
              <v-col cols="2">
                <div class="icon"></div>
                <span class="percentage">0.6%</span>
                <span>Casino Rebate(%)</span>
              </v-col>
              <v-col cols="2">
                <div class="icon"></div>
                <span class="percentage">0.6%</span>
                <span>Sports Rebate(%)</span>
              </v-col>
              <v-col cols="2">
                <div class="icon"></div>
                <span class="percentage">0.6%</span>
                <span>Slots Rebate(%)</span>
              </v-col>
              <v-col cols="2">
                <div class="icon"></div>
                <span class="percentage">0.6%</span>
                <span>Casino Rebate(%)</span>
              </v-col>
              <v-col cols="2">
                <div class="icon"></div>
                <span class="percentage">0.6%</span>
                <span>Sports Rebate(%)</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-row>
    </v-row>
    <v-snackbar class="pa-0" style="z-index:1000 !important;top:7%" light timeout="-1" v-model="alertShow" width="fit-content" top centered>
      <v-alert
        v-model="alertShow"
        dismissible
        :icon="alertSuccess ? 'mdi-check-circle-outline' : 'mdi-close'"
        class="mb-0 pa-1"
        :class="alertSuccess ? 'profile-alert-success' : 'profile-alert-failed'"
        light
        close-icon="mdi-close"
      >
        {{ alertMessage }}
      </v-alert>
    </v-snackbar>
  </div>
</template>

<script>
import stringFormat from 'string-format'
import { formValidator, uiHelper, locale } from '@/util'
import {
  MEMBER_CHECK_USERNAME,
  MEMBER_RESET_CHECK_USERNAME,
  MEMBER_REGISTER,
  MEMBER_SMS_REQUEST,
  MEMBER_SMS_VERIFY,
  MEMBER_GET_SMS_REQUIREMENT,
  MEMBER_RESET_SMS_VERIFICATION,
  MEMBER_LOGIN,
  MEMBER_RESET_LOGIN_STORE,
  ONE_SIGNAL_PLAYER_IDS_RESET_STORE,
  MEMBER_RESET_MOBILE_LOGIN_STORE
} from '@/store/member.module'
import { SESSION, SHARED } from '@/constants/constants'
import { errorCodeHelper } from '@/util/error-code-helper'
import { CMS_REGISTRATION_BANNER_ACTIVE } from '@/store/cms.module'
import { ROUTE_NAME } from '@/constants/route.constants'
import AppForgotPassword from '@/components/member/forgotPassword.vue'

export default {
  name: 'appLogin',
  components: { AppForgotPassword },
  mounted() {},
  props: {
    openLoginDialog: {
      type: Function,
      required: false,
      default: () => {}
    },
    loginErrorMsg: {
      type: String,
      required: true,
      default: ''
    }
  },
  created() {
    this.metaTag()
    this.getRegistrationBanner()
  },
  data: () => ({
    fullPageLoginErrMsg: '',
    forgotPasswordDialogShow: false,
    // openForgotPasswordDialog: {
    //   type: Function,
    //   required: true,
    //   default: () => {}
    // },
    loginObj: {
      memberCode: '',
      password: '',
      domain: '',
      platform: '',
      option: SHARED.DEFAULT_LOGIN_PASSWORD_METHOD
    },
    showRegisterGuide: false,
    currentCurrency: uiHelper.getCurrency(),
    currentLanguage: uiHelper.getLanguage(),
    defaultLanguage: SHARED.DEFAULT_LANGUAGE,
    registerTncUrl: '',
    registerTncDialog: {
      show: false,
      title: locale.getMessage(`label.registerAccountAgreement`)
    },
    validator: formValidator,
    stringFormat: stringFormat,
    isReferralCodeReadonly: false,
    confirmNewPassword: '',
    mobileNumberPrefixList: [
      {
        text: '+91',
        value: '91',
        currency: 'INR',
        lang: 'id'
      },
      {
        text: '+880',
        value: '880',
        currency: 'BDT',
        lang: 'bd'
      }
    ],
    currencyList: ['INR', 'BDT'],
    registerObj: {
      memberCode: '',
      password: '',
      currency: SHARED.DEFAULT_CURRENCY,
      email: '',
      dialCode: SHARED.DEFAULT_CURRENCY == 'BDT' ? '880' : '91',
      mobileNumber: '',
      verificationCode: '',
      line: '',
      referralCode: '',
      isEarlyBird: '0',
      domain: '',
      language: SHARED.DEFAULT_LANGUAGE,
      platform: '',
      fp: '',
      agent_team: '',
      utm_source: uiHelper.getCookie(SESSION.UTM_SOURCE),
      utm_medium: uiHelper.getCookie(SESSION.UTM_MEDIUM),
      utm_campaign: uiHelper.getCookie(SESSION.UTM_CAMPAIGN),
      s2: uiHelper.getCookie(SESSION.UTM_S2),
      pid: uiHelper.getCookie(SESSION.PID),
      c_id: uiHelper.getCookie(SESSION.CLICKID)
    },
    confirmedPassword: '',
    step: 0,
    regSteps: 2,
    errorMsg: undefined,
    userNameErrorMsg: undefined,
    alertShow: false,
    alertSuccess: false,
    alertMessage: ''
  }),
  computed: {
    selfLoginResponseComplete() {
      return this.$store.state.member.mobileLoginResponse.complete
    },
    memberInfo() {
      return this.$store.state.member.info
    },
    // loginResponseComplete() {
    //   return this.$store.state.member.loginResponse
    // },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    smsRequired() {
      return this.$store.state.member.smsVerificationRequired.required
    },
    smsVerificationSent() {
      return this.$store.state.member.smsVerificationSent.success
    },
    smsVerificationResult() {
      return this.$store.state.member.smsVerificationResult.success
    },
    smsVerificationError() {
      return this.$store.state.member.smsVerificationResult.message
    },
    smsRequestError() {
      return this.$store.state.member.smsVerificationSent.message
    },
    smsRequestAvailable() {
      return this.$store.state.member.smsVerificationSent.countDownTimer <= 0
    },
    smsCountdownTimer() {
      return this.$store.state.member.smsVerificationSent.countDownTimer.toString()
    },
    checkUsernameResult() {
      return this.$store.state.member.checkUsernameResult.completed
    },
    watchCurrency() {
      return this.registerObj.currency
    },
    registrationBannerContent() {
      return this.$store.state.cms.registrationBannerContent
    }
    // registerResult() {
    //   //console.log('registerResult', this.$store.state.member.registerResponse.complete)
    //   return this.$store.state.member.registerResponse.complete
    // }
  },
  watch: {
    selfLoginResponseComplete() {
      //only handle to display single page login error msg , redirection still handled by layoutmaster.vue 's loginResp complete
      let response = this.$store.state.member.mobileLoginResponse
      if (response.code != 0 && !response.success) {
        this.fullPageLoginErrMsg = errorCodeHelper.getErrorCodeDesc(response.code)
      }
      this.$store.dispatch(`${MEMBER_RESET_MOBILE_LOGIN_STORE}`)
    },
    // loginResponseComplete() {
    //   let response = this.$store.state.member.loginResponse
    //
    //   if (response.complete) {
    //     try {
    //       this.$ga.event('Account', `Login`, `${response.success ? 'Success' : 'Fail'}${!response.success ? ` [Error : ${response.code}]` : ''}`)
    //     } catch (err) {
    //       console.log('Google Analytics Error:', err)
    //     }
    //
    //     if (response.success) {
    //       this.setGoogleAnalyticUserId()
    //     }
    //
    //     this.loginResponseCompleteDialog(response)
    //     this.$store.dispatch(`${MEMBER_RESET_LOGIN_STORE}`)
    //     this.$store.dispatch(`${ONE_SIGNAL_PLAYER_IDS_RESET_STORE}`)
    //     this.goHome()
    //   }
    // },
    isLoggedIn() {
      this.$refs.loginForm.reset()
    }
  },
  methods: {
    goToLoginPage() {
      this.$router.push({
        name: ROUTE_NAME.LOGIN,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    setGoogleAnalyticUserId() {
      if (this.memberInfo.memberCode != '') this.$ga.set('userId', this.memberInfo.memberCode)
    },
    // loginResponseCompleteDialog(response) {
    //   if (response.code != 0 && !response.success) {
    //     this.loginErrorMsg = errorCodeHelper.getErrorCodeDesc(response.code)
    //   } else {
    //     this.currentCurrency = uiHelper.getCurrency()
    //   }
    // },
    openForgotPasswordDialog() {
      this.forgotPasswordDialogShow = true
    },
    closeForgotPasswordDialog() {
      this.forgotPasswordDialogShow = false
    },
    login() {
      if (this.$refs.loginForm.validate()) {
        let jObj = this
        this.loginObj.domain = uiHelper.getHostname()
        this.loginObj.platform = uiHelper.getPlatform()
        this.loginObj.language = uiHelper.getLanguage()
        let loginObj = this.loginObj
        this.$store.dispatch(`${MEMBER_LOGIN}`, {
          loginObj
        })
      }
    },
    goHome() {
      this.$refs.loginForm.reset()
      this.$router.push({
        name: ROUTE_NAME.HOME,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    openRegister() {
      this.$refs.loginForm.reset()
      // this.openRegisterDialog()
      this.$router.push({ name: ROUTE_NAME.REGISTER, params: { lang: this.$route.params.lang } })
    },
    openLogin() {
      this.$refs.loginForm.reset()
      // this.openRegisterDialog()
      this.$router.push({ name: ROUTE_NAME.LOGIN, params: { lang: this.$route.params.lang } })
    },
    closeShowRegisterGuide() {
      this.showRegisterGuide = false
    },
    metaTag() {
      uiHelper.setMetaTag('url', 'https://www.bhai88.com/en-BD/login/')
      uiHelper.setTitle(`${locale.getMessage('meta.home_title')}`)
      uiHelper.setMetaTag('description', `${locale.getMessage('meta.home_description')}`)
      uiHelper.setMetaTag('keywords', `${locale.getMessage('meta.home_keyword')}`)
      // uiHelper.setCanonical('https://www.bhai88.com/en-BD/login/')
      const currentUrl = window.location.href
      uiHelper.setCanonical(currentUrl)
    },
    openPageDialog(dialog) {
      this.$eventHub.$emit('open-page-dialog', dialog)
    },
    closeRegisterTncDialog() {
      this.registerTncDialog.show = false
    },
    formatSeconds(secs) {
      const pad = n => (n < 10 ? `0${n}` : n)

      const h = Math.floor(secs / 3600)
      const m = Math.floor(secs / 60) - h * 60
      const s = Math.floor(secs - h * 3600 - m * 60)

      return `${pad(m)}:${pad(s)}`
    },
    openAlert(success, msg) {
      this.alertSuccess = success
      this.alertMessage = msg
      this.alertShow = true
    },
    getRegistrationBanner() {
      let obj = {
        language: uiHelper.getLanguage()
      }
      this.$store.dispatch(`${CMS_REGISTRATION_BANNER_ACTIVE}`, {
        obj
      })
    }
  }
}
</script>

<style lang="scss">
.login-page-login-button {
  background: transparent linear-gradient(180deg, #c817c2 0%, #c817c2 0%, #000000 100%);
  color: #fff;
}
.login-page-register-button {
  background-color: #111a1e;
  color: #fff;
}
.forgot-password {
  margin-bottom: 12px;
  color: white;

  .theme--dark.v-btn {
    color: white;
  }

  .v-btn {
    color: white;
  }

  .v-btn:hover {
    text-decoration: underline;
    color: var(--v-primary-base);
    cursor: pointer;
  }

  .v-btn::before {
    color: white;
    background-color: unset;
  }
}
.registerTitle {
  color: #ffc000;
  font-size: 18px;
}
.rebate-display {
  padding-top: 12px;
  .icon {
    margin: 8px auto;
    width: 76px;
    height: 76px;
    /* UI Properties */
    background: transparent linear-gradient(180deg, #770073 0%, #0f000e 100%) 0% 0% no-repeat padding-box;
    border: 1px solid #413275;
    border-radius: 42px;

    img {
      margin: 0 auto;
    }
  }
  .percentage {
    display: block;
    color: #ffc000;
    font-size: 14px;
    margin-bottom: 4px;
  }
  font-size: 12px;
  color: white;
  text-align: center;
}

.loginPageGuideSection {
  position: relative;
  padding: 12px;
  font-size: 16px;
  background: #3d3360;
  //margin: -16px !important;
  margin-bottom: 10px !important;
}
.login_panel {
  justify-content: center;

  .left-container {
    padding: 20px 12px !important;
    background: transparent linear-gradient(134deg, #3d3360 0%, #0f0a20 100%) 0 0 no-repeat padding-box;

    label {
      color: white;
    }
  }

  .right-container {
    padding: 16px 20px !important;
    border-radius: 4px;
    background: #322c44;
  }

  .login_wrapper {
    max-width: 1240px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    gap: 1em;

    .sign-up-title {
      justify-content: center;
      color: var(--v-secondary-base);
      border-bottom: 1px solid var(--v-secondary-base);
      padding-bottom: 0.5em;
      margin-bottom: 1.5em;
    }

    .circle-button {
      padding: 12px;
      font-size: 12px;
      border-radius: 8px;
      height: 45px;
      color: #322c44;
      background: #ffc000;
    }

    .circle-button:hover {
      background-color: var(--v-primary-base);
    }

    .otp-button {
      background-color: var(--v-primary-base);
      border-radius: 4px;
    }

    .v-select__selection {
      color: #000000;
    }

    .input-field .v-icon,
    .input-field .v-input__icon {
      color: var(--v-primary-base);
    }

    .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner {
      margin-top: 0px;
    }
  }
}

.registerformfield .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
  font-size: 14px;
}

@media (min-width: 960px) {
  .registerformfield .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
    font-size: 16px;
  }
}

@media (max-width: 960px) {
  .login_panel::after {
    content: '';
    position: absolute;
    left: 0;
    width: 50%;
    height: 2px;
    background: linear-gradient(270deg, #b327ae00 0%, #ff5ae4 48%, #b327ae00 100%);
  }
  .loginPageGuideSection {
    font-size: 12px !important;
    margin: 8px !important;
  }
  .login_panel {
    background-color: #1c1632;
  }
  .login_panel .left-container {
    padding: 8px 12px !important;
    background: #1c1632;
  }
}
@media (max-width: 599px) {
  .login_panel {
    background-color: #1c1632;

    .login_wrapper {
      border: unset;
    }
  }
}
</style>
